"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function PublishPirceMobile(props) {
    var _a = props.mainList, mainList = _a === void 0 ? [] : _a, _b = props.headerList, headerList = _b === void 0 ? [] : _b;
    /**
     * 渲染移动端描述列表
     */
    function rendeHeaderList(hItem, i, index) {
        var title = hItem.title, desc = hItem.desc;
        if (index !== i)
            return null;
        return (react_1.default.createElement("div", { className: "content-item-header-wrap-mo", key: i },
            title,
            " \u00A0\u00A0",
            desc ? desc : null));
    }
    /**
     * 渲染移动端描述列表
     */
    function rendeContentList(item, index, headerList) {
        var title = item.title, desc = item.desc;
        return (react_1.default.createElement("div", { className: "content-item-mo", key: index },
            react_1.default.createElement("div", { className: "item-title-wrap" },
                react_1.default.createElement("div", { className: "title-mo" }, title),
                desc ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", null, " / "),
                    react_1.default.createElement("div", { className: "desc-mo" }, desc))) : null), headerList === null || headerList === void 0 ? void 0 :
            headerList.map(function (hItem, i) {
                return rendeHeaderList(hItem, i, index);
            })));
    }
    /**
     * 渲染移动端item
     */
    function rendeItem(item, index, headerList) {
        var columnTitle = item.columnTitle, _a = item.contentList, contentList = _a === void 0 ? [] : _a;
        return (react_1.default.createElement("div", { className: "content-mo", key: index },
            react_1.default.createElement("div", { className: "content-title-mo" },
                react_1.default.createElement("div", { className: "title-mo" }, columnTitle)),
            react_1.default.createElement("div", { className: "content-list-mo" }, contentList === null || contentList === void 0 ? void 0 : contentList.map(function (item, index) {
                return rendeContentList(item, index, headerList);
            }))));
    }
    return (react_1.default.createElement("div", { className: "publish-price-mo" }, mainList === null || mainList === void 0 ? void 0 : mainList.map(function (item, index) {
        return rendeItem(item, index, headerList);
    })));
}
exports.default = PublishPirceMobile;
//# sourceMappingURL=PublishPriceMobile.js.map